import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Banking" hint="BankAccount + reconciliation from the finance engine." /> }
